import React from "react";
import { CheckCircle2, Sparkles } from "lucide-react";

const SkillsCovered = ({ fetchCourse }) => {
  
  // Convert HTML string into an array of items
  const parseDescription = () => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(
      fetchCourse?.courseOutDescription || "",
      "text/html"
    );
    const items = Array.from(doc.querySelectorAll("li")).map(
      (li) => li.textContent
    );
    return items;
  };

  const courseItems = parseDescription();
  
  return (
    <>
      {courseItems.length > 0 && (
        <section className="skills-section">
          <div className="skills-container">
            {/* Header Block */}
            <div className="max-w-3xl mb-10">
              <span className="pd-badge mb-4">
                <Sparkles size={11} className="text-blue-500 animate-pulse" />
                Key Competencies
              </span>
              <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
                {courseItems.length}+ Skills Covered
              </h2>
            </div>

            {/* Render Parsed Course Description in Grid Format */}
            <div className="skills-grid">
              {courseItems?.map((item, index) => (
                <div key={index} className="skill-pill-card">
                  <div className="skill-icon-wrap">
                    <CheckCircle2 size={16} />
                  </div>
                  <p className="skill-text">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default SkillsCovered;
